import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { STATEFUL_ENTITIES } from '../../../data/enums/GraphQL';
import withLoading from '../../../utils/composition/withLoading';
import { Pagination, BulkDelete } from '../../../v4/components';
import { dataProps, paginationProps } from '../../../data/enums/Component';
import { PERMISSION_OBJ } from '../../../data/enums/Permission';
import { TableBody, TableHeader } from './tableConfig';

const propTypes = {
  data: dataProps.value,
  pagination: paginationProps.value,
  onPageChange: PropTypes.func,
  onCheckBoxClick: PropTypes.func,
  onIconClick: PropTypes.func,
  onBulkDelete: PropTypes.func.isRequired,
  permission: PropTypes.shape({
    read: PropTypes.bool,
    create: PropTypes.bool,
    update: PropTypes.bool,
    delete: PropTypes.bool,
  }),
  lastLocation: PropTypes.instanceOf(Object),
};

const defaultProps = {
  data: dataProps.defaultValue,
  pagination: paginationProps.defaultValue,
  onPageChange: () => null,
  onCheckBoxClick: () => null,
  onIconClick: () => null,
  permission: PERMISSION_OBJ,
  lastLocation: {},
};

const View = ({ ...props }) => {
  const { data, onPageChange, onIconClick, pagination, permission, onBulkDelete, lastLocation } = props;

  return (
    <Fragment>
      <BulkDelete
        data={data.list}
        type={STATEFUL_ENTITIES.TOWN}
        handler={onBulkDelete}
        render={(checkedList, primaryCheckboxHandler, secondaryCheckboxHandler) => (
          <div className='table-wrap'>
            <table>
              {TableHeader({
                dataListLength: data.list.length,
                checkedListLength: checkedList.length,
                primaryCheckboxHandler,
                permission,
                lastLocation,
              })}
              <tbody>
                {data.list.map((town) =>
                  TableBody({
                    data: town,
                    checkedList: checkedList,
                    onIconClick,
                    secondaryCheckboxHandler,
                    permission,
                  }),
                )}
              </tbody>
            </table>
          </div>
        )}
      />
      <Pagination
        currentPage={pagination.page}
        limit={pagination.limit}
        totalItems={data.total}
        onPageChange={onPageChange}
      />
    </Fragment>
  );
};

View.propTypes = propTypes;

View.defaultProps = defaultProps;

const LoginViewWithErrorAndLoading = withLoading(View);

export default LoginViewWithErrorAndLoading;
